export default "__VITE_ASSET__8L_zjSCj__"